import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaTruck, FaIdCard, FaLeaf, FaHeart } from 'react-icons/fa';
import ServicesSection from './ServicesSection';
import AboutCardSection from './AboutCardSection';

const AboutUs = () => {
  const services = [
    {
      icon: <FaTruck size={30} color="#336734" />,
      title: 'Livraison rapide',
      subtitle: 'dans tout le maroc',
    },
    {
      icon: <FaIdCard size={30} color="#336734" />,
      title: 'Produits bénéficiant de plusieurs licences',
      subtitle: 'DMP, ONSSA',
    },
    {
      icon: <FaLeaf size={30} color="#336734" />,
      title: 'Ingrédients d’exception',
      subtitle: 'Ingrédients rares, purs, efficaces.',
    },
    {
      icon: <FaHeart size={30} color="#336734" />,
      title: 'Satisfaction prouvée',
      subtitle: 'Satisfaction, efficacité, confiance.',
    },
  ];

  return (
    <Container className="py-5">
<h2
  className="text-center fw-bold mb-3"
  style={{ color: '#336734', fontSize: '2rem' }}
>
À propos de nous</h2>
      <p className="text-center text-muted mb-5">
Chez Élancia Bio, nous croyons que la beauté et la santé sont les deux visages d’un même voyage : un équilibre intérieur qui se reflète en éclat et en confiance à l’extérieur.

Notre nom s’inspire du mot Élan, symbole de force et de vitalité, représentant le combat quotidien que chacun – homme ou femme – mène face aux défis de la vie, dans la quête d’équilibre, de puissance et de bien-être.

Nous nous engageons à offrir des produits de beauté et des compléments alimentaires naturels, alliant pureté de la nature et innovations scientifiques.
Chaque produit est conçu selon les normes internationales les plus strictes et validé par le Ministère de la Santé, avec des ingrédients rigoureusement sélectionnés, pour garantir des résultats sûrs, efficaces et durables.
</p>
                 <AboutCardSection />

    </Container>
  );
};

export default AboutUs;
